import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPracticeReviews,
  fetchProviderslistitem,
  updatePracticeReviews,
  updateReviewList,
} from "./ReviewsAction";
import { getApiErrorMessage } from "../../../utils/commonUtilities";

const practiceReviewList = createSlice({
  name: "practiceReviewList",
  initialState: {
    isReviewsLoading: false,
    reviewsData: [],
    reviewListerrMsg: "",
    reviewsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeReviews.pending, (state) => {
        state.isReviewsLoading = true;
        state.reviewsError = null;
      })
      .addCase(fetchPracticeReviews.fulfilled, (state, action) => {
        state.isReviewsLoading = false;
        if (!action.payload.success) {
          state.isReviewsLoading = true;
          state.reviewListerrMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isReviewsLoading = false;
          state.reviewsData =
            action.payload.data.data.practiceSurveyResponseDto;
        }
      })
      .addCase(fetchPracticeReviews.rejected, (state, action) => {
        state.isReviewsLoading = false;
        state.reviewsError = action.error.message;
      });
  },
});

const providersListItem = createSlice({
  name: "providersListItem",
  initialState: {
    isProvidersLoading: false,
    providersData: [],
    providersListerrMsg: "",
    providersError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderslistitem.pending, (state) => {
        state.isProvidersLoading = true;
        state.providersError = null;
      })
      .addCase(fetchProviderslistitem.fulfilled, (state, action) => {
        state.isProvidersLoading = false;
        if (!action.payload.success) {
          state.isProvidersLoading = true;
          state.providersListerrMsg = getApiErrorMessage(action.payload.status);
          state.providersData = []
        } else {
          state.isProvidersLoading = false;
          state.providersData =
            action.payload.data.data.surveyPracticeInfoDTO[0];
        }
      })
      .addCase(fetchProviderslistitem.rejected, (state, action) => {
        state.isProvidersLoading = false;
        state.providersError = action.error.message;
      });
  },
});

const updateReview = createSlice({
  name: "updateReview",
  initialState: {
    isReviewUpdateLoading: false,
    reviewUpdateData: [],
    reviewUpdateerrMsg: "",
    reviewUpdateError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePracticeReviews.pending, (state) => {
        state.isReviewUpdateLoading = true;
        state.reviewUpdateError = null;
      })
      .addCase(updatePracticeReviews.fulfilled, (state, action) => {
        state.isReviewUpdateLoading = false;
        if (!action.payload.success) {
          state.isReviewUpdateLoading = true;
          state.reviewUpdateerrMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isReviewUpdateLoading = false;
          state.reviewUpdateData =
            action.payload.data.data.flagReviewResponseDTO;
        }
      })
      .addCase(updatePracticeReviews.rejected, (state, action) => {
        state.isReviewUpdateLoading = false;
        state.reviewUpdateError = action.error.message;
      });
  },
});

const updateReviewLists = createSlice({
  name: "updateReviewLists",
  initialState: {
    isUpdateReviewListLoading: false,
    updatereviewListData: [],
    updatereviewListerrMsg: "",
    updateReviewListError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateReviewList.pending, (state) => {
        state.isUpdateReviewListLoading = true;
        state.updateReviewListError = null;
      })
      .addCase(updateReviewList.fulfilled, (state, action) => {
        state.isUpdateReviewListLoading = false;
        if (!action.payload.success) {
          state.isUpdateReviewListLoading = true;
          state.updatereviewListerrMsg = getApiErrorMessage(
            action.payload.status
          );
        } else {
          state.isUpdateReviewListLoading = false;
          state.updatereviewListData =
            action.payload.data.data.providerSurveyReviewDTO;
        }
      })
      .addCase(updateReviewList.rejected, (state, action) => {
        state.isUpdateReviewListLoading = false;
        state.updateReviewListError = action.error.message;
      });
  },
});

export const practiceReviewsReducer = practiceReviewList.reducer;
export const practiceReviewProviderListReducer = providersListItem.reducer;
export const updateReviewReducer = updateReview.reducer;
export const updateReviewListsReducer = updateReviewLists.reducer;
